import { themeGetColor } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const PageContainer = styled.div `
  display: flex;
  flex-direction: row;
  height: 100vh;
  justify-content: flex-start;
  width: 100%;
  overflow: hidden;
  background-color: ${themeGetColor('background.100', 0.5)};
`;
